require('../../modules/es.object.values');
var path = require('../../internals/path');

module.exports = path.Object.values;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/object/values.js
// module id = 1003
// module chunks = 0